<template>
  <div v-loading="$wait.waiting(_uid)">
    <div class="text-right wrapper-button control-button-wrapper pt-xxs">
      <button
        class="btn btn-cancel btn-primary btn-wd submit-button"
        @click="cancelShow"
      >
        Back
      </button>

      <acl :permissions="['companies_users_update']">
        <button
          class="btn btn-info btn-fill btn-wd submit-button"
          @click.prevent="handleEditUser"
        >
          Edit
        </button>
      </acl>
    </div>

    <div class="row mt-s">
      <div class="col-xs-12 col-md-6">
        <div>
          <b>Name</b>

          <ul class="list-unstyled mt-xxxs">
            <li>{{ user.fullName }}</li>
          </ul>
        </div>

        <div class="mt-s">
          <b>User Type</b>

          <ul class="list-unstyled mt-xxxs">
            <li>{{ _joinByName(user.acl.roles) }}</li>
          </ul>
        </div>
      </div>

      <div class="col-xs-12 col-md-6">
        <div>
          <b>ID</b>

          <ul class="list-unstyled mt-xxxs">
            <li>{{ user.uuid }}</li>
          </ul>
        </div>

        <div class="mt-s">
          <b>Username</b>

          <ul class="list-unstyled mt-xxxs">
            <li>{{ user.username }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="isTrainee">
      <div class="row mb-s pb-s">
        <div class="col-xs-12">
          <hr />
          <h5 class="text-info">
            <b>Operational Information</b>
          </h5>
        </div>

        <div class="col-xs-12 col-md-3">
          <b>Group</b>
          <ul class="list-unstyled mt-xxxs">
            <li v-for="group in user.groups" :key="group.id">
              <router-link
                :to="{
                  name: 'companies_groups@show',
                  params: { id: group.id },
                }"
              >
                {{ group.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- <div class="col-xs-12 col-md-3">
          <b>
            Registry, Purpose, Equipment
          </b>
          <ul class="list-unstyled mt-xxxs">
            <li
              v-for="rpe in user.company.rpe"
              :key="rpe.id"
            >
              {{ rpe.name }}
            </li>
          </ul>
        </div> -->

        <div v-if="userRoleList.length" class="col-xs-12 col-md-3">
          <!-- <b>Roles</b> -->
          <ul class="list-unstyled mt-xxxs">
            <li v-for="role in userRoleList" :key="role.id">
              <b> {{ role.name }} Licence: </b>
              <div>
                <!-- <span class="text-gray-500">Licence:</span> -->
                <!-- <span class="ml-xxxs">{{ role.licence }}</span> -->
                {{ role.licence }}
              </div>
            </li>
          </ul>
        </div>

        <!-- <div class="col-xs-12 col-md-2">
          <b>Hemisphere</b>
          <ul class="list-unstyled mt-xxxs">
            <li>
              {{ user.hemisphereName }}
            </li>
          </ul>
        </div> -->

        <div class="col-xs-12 col-md-3">
          <b>Subscription Renewal</b>
          <ul class="list-unstyled mt-xxxs">
            <li>
              {{ subscriptionEnd }}
            </li>
          </ul>
        </div>

        <div v-if="user.international_procedures" class="col-xs-12 col-md-3">
          <b>International Procedures</b>
          <ul class="list-unstyled mt-xxxs">
            <li>Enrolled</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row mb-s pb-s">
      <div class="col-xs-12">
        <hr />
        <h5 class="text-info">
          <b>Settings</b>
        </h5>
      </div>

      <div v-if="userSettings">
        <div class="col-xs-12">
          <b> Notifications </b>
          <ul class="list-unstyled mt-xxxs">
            <li>
              {{ userSettings.notifications ? "On" : "Off" }}
            </li>
          </ul>
          <div>
            <div class="mt-s">
              <b>Email</b>

              <ul class="list-unstyled mt-xxxs">
                <li>{{ user.email }}</li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
        <div class="col-xs-12">
          <label for="notification" class="mr-xs"> Suspend </label>
          <ul class="list-unstyled mt-xxxs">
            <li>
              {{ userSettings.suspend.status ? "On" : "Off" }}
            </li>
          </ul>

          <div class="mt-s">
            <b>Returns on</b>

            <ul class="list-unstyled mt-xxxs">
              <div v-if="!userSettings.suspend.status">N/A</div>
              <div v-if="userSettings.suspend.status">
                {{ userSettings.suspend.endDate }}
              </div>
            </ul>
          </div>

          <div class="mt-s">
            <b>Display on training status board</b>

            <ul class="list-unstyled mt-xxxs">
              <li>
                {{ userSettings.suspend.showTrainingStatus ? "On" : "Off" }}
              </li>
            </ul>
          </div>

          <div class="mt-s">
            <b>Display on event status board</b>

            <ul class="list-unstyled mt-xxxs">
              <li>
                {{ userSettings.suspend.showEventsStatus ? "On" : "Off" }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="clearfix" />
    </div>

    <div class="clearfix mb-s" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import _joinByName from "@helpers/joinByName";
import _capitalize from "lodash.capitalize";
import HelperDate from "@helpers/dates";
import parseSettings from "@components/Dashboard/Views/Pages/Company/Users/providers/parseSettings";

export default {
  components: {},
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    isTrainee() {
      const userAcl = this.user.acl.roles;
      return userAcl.some((acl) => acl.name === "Trainee");
    },
    subscriptionEnd() {
      return HelperDate.formatDate(this.user.subscription.end);
    },
    userRoleList() {
      const list = [];
      for (const role of this.user.company.roles) {
        if (!role.licence) {
          continue;
        }
        list.push(role);
      }
      return list;
    },
    userSettings() {
      return this.parseSettings(this.user.settings);
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseSettings,
    _capitalize,
    _joinByName,
    cancelShow() {
      return this.$router.push({ name: "companies_users@index" });
    },
    handleEditUser() {
      return this.$router.push({
        name: "companies_users@edit",
        params: { id: this.user.id },
      });
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 393px) {
  .pt-xxs {
    padding-left: 50%;
  }
  .btn {
    max-width: 140px;
  }
}
@media (max-width: 767px) and (min-width: 394px) {
  .pt-xxs {
    padding-left: 60%;
  }
  .btn {
    max-width: 140px;
  }
}
@media (max-width: 1025px) and (min-width: 768px) {
  .pt-xxs {
    padding-left: 75%;
  }
  .btn {
    max-width: 140px;
  }
}
</style>
